module.exports = __webpack_public_path__ + "static/media/saraiva_para_escolas.87490231.svg";